"use strict";
/* eslint @cspell/spellchecker: 0 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageCodes = void 0;
exports.languageCodes = [
    'AS',
    'BN',
    'BRX',
    'DOI',
    'EN',
    'GU',
    'HI',
    'KOK',
    'KN',
    'KS',
    'MAI',
    'ML',
    'MNI',
    'MR',
    'NE',
    'PA',
    'OR',
    'SA',
    'SAT',
    'SD',
    'TE',
    'TA',
    'UR',
    'ISL',
    'NRI',
];
//# sourceMappingURL=Languages.js.map